import {fromJS, Map} from 'immutable';
import myTop10GamesActions from '../../actions/fortnite-game/myTop10Games.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';
import {MyTop10Game, GameDataItem} from '../../types';

export interface MyTop10GamesItem {
    list: GameDataItem[];
    loading: boolean;
    error?: string;
    lastFetch?: Date;
}

export interface MyTop10GamesState {
    [MyTop10Game.ACTIVE_PLAYERS]: MyTop10GamesItem;
    [MyTop10Game.AVERAGE_PLAY_TIME]: MyTop10GamesItem;
    [MyTop10Game.PLAYER_RETENTION]: MyTop10GamesItem;
    [MyTop10Game.TOTAL_LIFE_TIME_PLAYS]: MyTop10GamesItem;
}

export const DEFAULT_STATE = fromJS({
    [MyTop10Game.ACTIVE_PLAYERS]: {list: [], loading: true},
    [MyTop10Game.AVERAGE_PLAY_TIME]: {list: [], loading: true},
    [MyTop10Game.PLAYER_RETENTION]: {list: [], loading: true},
    [MyTop10Game.TOTAL_LIFE_TIME_PLAYS]: {list: [], loading: true}
});

export const myTop10GamesReducer = (state: Map<string, any> = DEFAULT_STATE, action) => {
    const {data, error, value} = action.payload || {};

    switch (action.type) {
        case myTop10GamesActions.TYPES.GET_TOP_10_GAMES: {
            return state.merge({
                [value]: state.get(value).merge({
                    error: undefined,
                    loading: true
                })
            });
        }

        case myTop10GamesActions.TYPES.GET_TOP_10_GAMES_COMPLETE: {
            return state.merge({
                [value]: state.get(value).merge({
                    list: data,
                    lastFetch: Date.now(),
                    loading: false
                })
            });
        }

        case myTop10GamesActions.TYPES.GET_TOP_10_GAMES_FAILED: {
            return state.merge({
                [value]: state.get(value).merge({
                    error,
                    loading: false
                })
            });
        }

        default:
            return state;
    }
};

export default dieselReducer('myTop10Games', myTop10GamesReducer);
